import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ScalperSvg = (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.7766 17.627L6.54817 25.3527C6.28769 25.5973 6.36222 26.0228 6.69627 26.1496C7.65288 26.5126 9.40121 27.0859 10.6875 26.9892C12.7471 26.8344 13.9131 26.1512 15.6743 24.8079C16.3655 24.2806 17.2423 23.362 17.6662 22.9035C17.8171 22.7402 17.8369 22.4971 17.7186 22.3089L14.7766 17.627ZM14.7766 17.627L25.8472 7.23297C25.8472 7.23297 26.8379 6.48511 27.6424 7.66923C28.447 8.85336 27.6424 10.0375 27.6424 10.0375L16.7215 20.6946L14.7766 17.627Z"
        stroke="currentColor" strokeWidth="1.0"/>
    </svg>
)

const ScalperIcon: React.FC<SvgIconProps> = (props) => <SvgIcon {...props}>{ScalperSvg}</SvgIcon>

export default ScalperIcon